import React from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import * as Styled from './withScrollableTopTabs.styled';

function withScrollableTopTabs(tabsList, selectedTabIndex, replaceParams = []) {
  return (PageComponent) => {
    const WithTopTabs = (props) => {
      const { isSideBarOpen, ...rest } = props;

      const params = useParams();

      const history = useHistory();

      const onTabChange = (event, newValueIndex) => {
        const selectedTab = tabsList[newValueIndex] || null;
        if (!selectedTab) return;
        const { path } = selectedTab;
        let newUrl = replaceParams.reduce((acc, currentValue) => {
          if (!acc.includes(currentValue) || !params[`${currentValue}`])
            return acc;
          return acc.replace(`:${currentValue}`, params[currentValue]);
        }, path);
        history.push(newUrl);
      };

      return (
        <>
          <Styled.StaticContainer>
            <Styled.FixedContainer sidebar={isSideBarOpen ? 'true' : ''}>
              <Styled.ScrollTabs
                value={selectedTabIndex}
                textColor="primary"
                onChange={onTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                {tabsList.map((item) => {
                  return <Styled.ScrollTab label={item.name} key={item.name} />;
                })}
              </Styled.ScrollTabs>
            </Styled.FixedContainer>
          </Styled.StaticContainer>
          <PageComponent {...rest} />
        </>
      );
    };

    WithTopTabs.propTypes = {
      isSideBarOpen: PropTypes.bool.isRequired,
    };

    WithTopTabs.displayName = `WithScrollableTopTaps-${
      PageComponent.displayName || 'Component'
    }`;

    return connect((state) => ({
      isSideBarOpen: state.meta.isSideBarOpen,
    }))(WithTopTabs);
  };
}
export default withScrollableTopTabs;
